import { useState } from 'react';

import { Modal } from '@atom/mui';
import {
  AnalyticsFolderTree,
  AnalyticsFolderTree as FolderTree,
} from '@atom/types/analytics';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import SelectAnalyticsFolderTree from './SelectAnalyticsFolderTree';

export interface Props {
  title: string;
  openFolders: boolean;
  onClose: () => void;
  handleBulkMove: (data: AnalyticsFolderTree) => void;
}

const BulkMoveAnalyticsCardModal = ({
  openFolders,
  onClose,
  title,
  handleBulkMove,
}: Props) => {
  const [folder, setFolder] = useState<FolderTree>();

  const handleSelectFolder = (selected: FolderTree) => setFolder(selected);
  const handleSubmit = (): void => {
    handleBulkMove(folder);
  };

  return (
    <Modal
      title={title}
      open={openFolders}
      onCancel={onClose}
      onConfirm={handleSubmit}
      onExited={onClose}
      data-cy="bulkMoveAnalyticsCardModal"
      width="sm"
      confirmButtonText="Move"
      disabled={isNilOrEmpty(folder)}
    >
      <SelectAnalyticsFolderTree setFolder={handleSelectFolder} />
    </Modal>
  );
};

export default BulkMoveAnalyticsCardModal;
